module.exports = __webpack_public_path__ + "static/media/logoutIcons.5d644f2e.svg";